import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import './TimeZone.scss';
import moment from 'moment-timezone';

import Globe from 'assets/svgs/globe.svg';
import Info from 'assets/svgs/info.svg';

import { TIMEZONE_NAMES } from './TimeZoneNames';

import { find, isEmpty } from 'lodash';

const getFormatedUTC = () => {
  const tzOffset = moment.tz(moment.tz.guess()).utcOffset();

  const min = tzOffset % 60;
  const minutes = min ? ':' + Math.abs(min) : '';
  const hours = (tzOffset - min) / 60;

  return `${hours}${minutes} hours`;
};

const getTimeZone = () => {
  const tzAbbr = moment.tz(moment.tz.guess()).format('z');
  const timezone = find(TIMEZONE_NAMES, {
    Abbreviation: tzAbbr,
    Offset: getFormatedUTC(),
  });

  return isEmpty(timezone) ? moment.tz.guess() : `${timezone.Abbreviation}(${timezone.Name})`;
};

const TimeZone = (props) => {
  const { t } = useTranslation();

  setTimeout(
    () =>
      Array.from(document.querySelectorAll('[data-bs-toggle="tooltip"]')).forEach((el) =>
        bootstrap.Tooltip.getOrCreateInstance(el).enable()
      ),
    100
  );

  return (
    <div className="timezone">
      <div>
        {props.message ? <Info /> : null} {props.message}
      </div>
      <div data-bs-toggle="tooltip" data-bs-placement="top" title={t('timezone.tooltipMessage')}>
        <div className="timezone-abbr">{getTimeZone()}</div>
        {t('timezone.timezoneLabel')}
      </div>
      <div data-bs-toggle="tooltip" data-bs-placement="top" title={t('timezone.tooltipMessage')}>
        <Globe />
      </div>
    </div>
  );
};

TimeZone.propTypes = {
  message: PropTypes.string,
};

export default TimeZone;
